import { Navigate } from "@tanstack/react-router";
import { ROUTES } from "@/constants/routeConstants";
import { useAuthStore } from "@/store/auth";

export const RequireSignedIn = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const user = useAuthStore((s) => s.user);

  if (!user) {
    return <Navigate to={ROUTES.SIGN_IN} replace={true} />;
  }

  return children;
};
